import {Validation, type ValidationConfig, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";
import type {UploadData} from "../components/formUploadField";

export type FileSizeConfig = ValidationConfig<{
    id: string;
    maxSize: string;
}>;

export class MaxUploadSize extends Validation {

    private constructor(messageText: string, onlyWarning: WarningLevel, private maxSize: string) {
        super(messageText, onlyWarning);
    }

    public static from(config: FileSizeConfig): MaxUploadSize {
        return new MaxUploadSize(config.message, config.warningLevel, config.validation.maxSize);
    }

    protected valid(files: UploadData[]): boolean {
        return !files || files.every(file => this.fileValid(file));
    }

    private fileValid(file: UploadData): boolean {
        return file.size <= this.maxSizeInByte();
    }

    private maxSizeInByte(): number {
        let size: number;
        if (this.maxSize.endsWith("MB")) {
            size = Number.parseInt(this.maxSize.slice(0, -2)) * 1024 * 1024;
        } else if (this.maxSize.endsWith("kB")) {
            size = Number.parseInt(this.maxSize.slice(0, -2)) * 1024;
        } else {
            size = Number.parseInt(this.maxSize);
        }
        return size >= 0 ? size : 0;
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value?: T): void {
        const validationResponse: ValidationResponse = this.checkValidity(value);

        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }
}